import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


function MomtheraMyPageWithdrawalGuide() {
    const navigate = useNavigate();
    
    const [check, setCheck] = useState(false);


    function goToMyPageMain() {
        navigate("/dtx006/mypage");
    }

    return (
        <div className="dashboardContent dtx006">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
            <div className="mypage_withdrawal_wrapper">
                <div className="title_wrapper">
                    <div className="title">회원탈퇴</div>
                    <div className="description">회원 탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요.</div>
                </div>
                <div>
                    <div className="withdrawal_info_box">
                        <div className="section">
                            <p className="title">사용하고 계신 아이디(<span className="blue">{JSON.parse(localStorage.getItem('dtx006token')).email}</span>)는 탈퇴할 경우 재사용 및 복구가 불가능합니다.</p>
                            <p><span className="highlight">탈퇴한 아이디는 본인과 타인 모두 재사용 및 복구가 불가</span>하오니 신중하게 선택하시기 바랍니다.</p>
                        </div>
                        <div className="section">
                            <p className="title">탈퇴 후 회원정보 및 서비스 이용기록은 모두 삭제됩니다.</p>
                            <p>회원정보 및 서비스 이용기록은 모두 삭제되며, 삭제된 데이터는 복구되지 않습니다.</p>
                            <p>삭제되는 내용을 확인하시고 필요한 데이터는 미리 관리자(관리자 계정)에게 문의하시기 바랍니다.</p>
                        </div>
                        <div className="section">
                            <p className="title">탈퇴 후에도 전송한 메시지는 그대로 남아있습니다.</p>
                            <p>환자에게 전송한 메시지는 탈퇴 시 자동 삭제되지 않고 그대로 남아있습니다. </p>
                            <p>삭제를 원하는 메시지가 있다면 <span className="highlight">반드시 탈퇴 전 관리자(관리자 계정)에게 문의하시기 바랍니다.</span> </p>
                            <p>탈퇴 후에는 회원정보가 삭제되어 본인 여부를 확인할 수 있는 방법이 없어, 메시지를 임의로 삭제해드릴 수 없습니다.</p>
                        </div>
                        <div className="section2">
                            <p>탈퇴 후에는 아이디 <span className="blue">{JSON.parse(localStorage.getItem('dtx006token')).email}</span> 로 다시 가입할 수 없으며, 아이디와 데이터는 복구할 수 없습니다.</p>
                            <p>전송한 메시지는 탈퇴 후 삭제할 수 없습니다.</p>
                        </div>
                    </div>
                    <div className="withdrawal_check_wrapper">
                        <input
                            type="checkbox"
                            id="withdrawal-check"
                            onClick={()=>setCheck(!check)}
                        />
                        <label htmlFor="withdrawal-check">안내 사항을 모두 확인하였으며, 이에 동의합니다.</label>
                    </div>
                    <div className="withdrawal_button_wrapper">
                        <button className="withdrawal_btn" onClick={()=>navigate('/dtx006/mypage/withdrawal/identification')} disabled={!check}>다음</button>
                        <button className="cancel_btn" onClick={goToMyPageMain}>취소</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MomtheraMyPageWithdrawalGuide;